import { render } from "./EditSolarSubProduct.vue?vue&type=template&id=1c504c69"
import script from "./EditSolarSubProduct.vue?vue&type=script&lang=js"
export * from "./EditSolarSubProduct.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__